var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDclub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.80557C16.9773 4.69834 18.4071 4 20 4C22.9455 4 25.3333 6.38781 25.3333 9.33333C25.3333 12.2789 22.9455 14.6667 20 14.6667C18.4071 14.6667 16.9773 13.9683 16 12.8611M20 28H4V26.6667C4 22.2484 7.58172 18.6667 12 18.6667C16.4183 18.6667 20 22.2484 20 26.6667V28ZM20 28H28V26.6667C28 22.2484 24.4183 18.6667 20 18.6667C18.5429 18.6667 17.1767 19.0562 16 19.7369M17.3333 9.33333C17.3333 12.2789 14.9455 14.6667 12 14.6667C9.05448 14.6667 6.66667 12.2789 6.66667 9.33333C6.66667 6.38781 9.05448 4 12 4C14.9455 4 17.3333 6.38781 17.3333 9.33333Z",
    stroke: "#047B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDclub);
export default __webpack_public_path__ + "static/media/ic_dclub.600ae77d79b3658e18077376fbd4e4c3.svg";
export { ForwardRef as ReactComponent };